import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import React from 'react';
import SubNavItemLabel from '../SubNavItemLabel';

export interface SidemenuProps {
  navItem: NavItem;
  handleSubMenu: (string: string | undefined) => void;
}

const Wrapper = styled.div`
  flex: 4;
  display: flex;
  margin-left: 5rem;
  background-color: ${theme.colors.lightGray};
  padding: 3.5rem 0 0 5rem;

  @media (max-width: ${theme.breakpoints.optimalDesktop - 1}px) {
    margin-left: 2rem;
    padding: 3.75rem 2rem 0;
  }
  @media (max-width: ${theme.breakpoints.navDrawerBreak}px) {
    margin-left: 0px;
  }
`;

const SidemenuContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 25rem;
`;

const Sidemenus = styled.div`
  flex: 1;
  padding: 0.5rem 0;
  display: flex;
`;

const SidemenuItem = styled.div`
  min-width: 14rem;
  flex: 1;

  ${theme.mediaQueries.desktop} {
    display: grid;
    grid-template-rows: 20% 80%;
  }
  @media (max-width: ${theme.breakpoints.navDrawerBreak}px) {
    min-width: 12rem;
  }
`;

const StyledSubNavItemLabel = styled(SubNavItemLabel)`
  margin-bottom: 1.5rem;
  font-size: 0.9rem;

  ${theme.mediaQueries.desktop} {
    line-height: 1.15rem;
  }
  @media (max-width: ${theme.breakpoints.navDrawerBreak}px) {
    font-size: 0.8rem;
  }
`;

const StyledLinkContainer = styled.div``;

const StyledLink = styled(Link)`
  display: block;
  padding: 0.3rem 0;
  font-size: ${theme.typography.toRem(16)};
  line-height: ${theme.typography.toRem(16)};
  font-family: ${theme.typography.headerFont};
  font-weight: bold;
  transition: ${theme.transitions.create(['color'])};
  white-space: pre;

  :hover {
    color: ${theme.colors.mediumBlue};
    text-decoration: none;
  }
  @media (max-width: ${theme.breakpoints.navDrawerBreak}px) {
    font-size: 0.8rem;
  }
`;

interface GridProps {
  columnCount: number;
}

const Grid = styled.div<GridProps>`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(${({ columnCount }) => columnCount}, 1fr);
  grid-auto-rows: 14rem;
  margin: 0 auto;
  max-width: ${theme.breakpoints.desktop}px;
`;

function Sidemenu({ navItem, handleSubMenu }: SidemenuProps) {
  return (
    <Wrapper>
      <SidemenuContainer>
        <Sidemenus>
          <Grid columnCount={navItem.sidemenu ? 3 : 4}>
            {navItem.sidemenu?.map(sidemenu => (
              <SidemenuItem key={sidemenu.label}>
                <StyledSubNavItemLabel
                  onMouseEnter={() => {
                    handleSubMenu(sidemenu.label);
                  }}
                >
                  {sidemenu.label}
                </StyledSubNavItemLabel>
                <StyledLinkContainer>
                  {sidemenu.links.map(({ label, link }) => {
                    if (label === 'SmartHub Vault') {
                      return null;
                    }
                    return (
                      <StyledLink key={label} to={link}>
                        {label === 'SmartHub'
                          ? `${label} &\n  SmartHub Vault`
                          : label === 'Benefit Solutions - Crew & Talent'
                          ? `Benefit Solutions\n - Crew & Talent`
                          : label === 'Benefit Solutions - Production Companies'
                          ? `Benefit Solutions\n - Production Companies`
                          : `${label}`}
                      </StyledLink>
                    );
                  })}
                </StyledLinkContainer>
              </SidemenuItem>
            ))}
          </Grid>
        </Sidemenus>
      </SidemenuContainer>
    </Wrapper>
  );
}

export default React.memo(Sidemenu);
